<div fxLayout="column" class="cipo--height--full cipo--overflow--hidden">
    @if (screenConfig()?.dependencyFieldId) {
        <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="6px"
            class="p-x p-b-xs cipo-text--secondary">
            <mat-icon>account_tree</mat-icon>
            <span class="cipo--font-size--sm">
                {{ "gantt.dependencyRelation" | translate }}:&nbsp;
                <strong>{{ screenConfig().name }}</strong>
            </span>
        </div>
    }
    <div fxFlex="grow" fxLayoutAlign="center center" class="cipo--overflow--hidden">
        @if (isLoading()) {
            <mat-spinner diameter="60" />
        } @else if (rows().length) {
            @let isMobile = userStore.isSmallScreen();
            <highcharts-chart
                [options]="chartOptions()"
                [constructorType]="'ganttChart'"
                [update]="true"
                [oneToOne]="true"
                [style.width]="isMobile ? ganttMobileChartWidthPx + 'px' : '100%'"
                class="cipo--height--full cipo--display--block" />
        } @else {
            <cipo-not-found title="notFound.nothingFound" icon="view_timeline" class="cipo--width--full" />
        }
    </div>
</div>
